import { createSelector } from '@ngrx/store';
import { ErrorMessage } from '../error/error-message.model';
import { contentListSearchSelectors, contentListSelectors } from './content.entity';
import { Content, DNComment } from './content.model';
import { ContentState, selectContentState } from './content.state';

// Lista
export const selectListError = createSelector(
	selectContentState,
	(state: ContentState): ErrorMessage => state.contentsList.error
);

export const selectList = createSelector(
	selectContentState,
	(state: ContentState) => state.contentsList
);

export const selectAllList = createSelector(selectList, contentListSelectors.selectAll);

export const selectSearchList = createSelector(
	selectContentState,
	(state: ContentState) => state.contentsSearchList
);

export const selectAllSearchList = createSelector(
	selectSearchList,
	contentListSearchSelectors.selectAll
);
// Current
export const selectCurrentContentState = createSelector(
	selectContentState,
	(state: ContentState) => state.currentContent
);

export const selectCurrentContent = createSelector(
	selectContentState,
	(state: ContentState) => state.currentContent.entities[state.currentContent.ids[0]]
);

export const selectAbilitatoCurrentContent = createSelector(
	selectCurrentContent,
	(content: Content) => (content ? content.abilitato : 0)
);

export const selectPremiumCurrentContent = createSelector(
	selectCurrentContent,
	(content: Content) => (content ? content.premium : 0)
);
export const selectCurrentError = createSelector(
	selectContentState,
	// TODO: currentcontent è undefined
	(state: ContentState): ErrorMessage => state?.currentContent?.error
);

export const selectContentByID = (value: number) =>
	createSelector(selectList, (content) => content.entities[value]);

// Comments

export const selectCurrentContentComments = createSelector(
	selectCurrentContentState,
	(state) => state.comments
);

export const selectCommentsByParentId = (parentId: number) =>
	createSelector(selectCurrentContentComments, (comments: DNComment[]) =>
		getRepliesByParentId(comments, parentId)
	);

// Media
export const selectTemporaryMediaName = createSelector(
	selectCurrentContentState,
	(state) => state.temporaryMediaName
);

// BFS over n-ary tree implementation
function getRepliesByParentId(root: DNComment[], rootId: number): DNComment[] {
	const temp: DNComment[][] = [];
	const result: DNComment[][] = [];

	temp.push(root);

	while (temp.length > 0 && result.length === 0) {
		const current: DNComment[] = temp.shift() || [];

		for (const comment of current) {
			if (comment.idContenuto === rootId) {
				result.push(comment.replies);
			} else {
				temp.push(comment.replies);
			}
			if (result.length !== 0) break;
		}
	}

	return result.pop();
}
